export default "__VITE_ASSET__B8q68c3S__"